import React from "react";

// Context
import "./Color.css";

function Color({ hue }) {
  const selectColor = (element) => {
    const elementId = element.target.id;
    const elementHue = document.getElementById(elementId).getAttribute("hue");
    document.querySelector(".textEditor").focus();
    document.execCommand("foreColor", false, elementHue);
  };
  return (
    <>
      <button
        className="color"
        hue={hue}
        id={`color-${hue.replace("#", "")}`}
        style={{ backgroundColor: hue }}
        onClick={selectColor}
      ></button>
    </>
  );
}

export default Color;
